import React from 'react';
import CommonScatterBubblePlot from './CommonScatterBubblePlot';
import AxesReset from '../custom_layers/AxesReset';
import LinearTrendline from '../custom_layers/LinearTrendline';

function ScatterPlot(props) {
  return (
    <CommonScatterBubblePlot
      {...props}
      layers={['grid', LinearTrendline, 'nodes', AxesReset, 'markers']}
    />
  );
}

export default ScatterPlot;
